module.exports = __webpack_public_path__ + "img/antes_despues_189.d861b141.png";